var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarkerGoImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#414042",
    d: "M8 2.2L3.6 13.3 8 11l4.4 2.3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerGoImg);
export default __webpack_public_path__ + "static/media/marker_go_img.a1ebaf05fc3225b3f78e27ad4d74b1c4.svg";
export { ForwardRef as ReactComponent };